// extracted by mini-css-extract-plugin
export default {"modalBoxContainer":"renameModal_modalBoxContainer__YaX8b"};